import React from 'react';
import styles from './categoryCard.module.scss';
import { SimpleCategoryItemTypes } from '../../../../../../Interfaces/componentTypes';
import { PlusIcon, Settings, SmallTrash } from '../../../../../../Assets/Icons';

interface IProps {
  id?: number,
  title: string,
  onClick: () => void,
  type?: SimpleCategoryItemTypes,
  isAutor?: boolean,
  onDelete?: (id:number,title:string) => void
};

const SimpleCategoryCard: React.FC<IProps> = (props) => {
  const { title, onClick, type = SimpleCategoryItemTypes.ITEM, isAutor,id,onDelete } = props;
  const handleDeleteClick = (
    e: React.MouseEvent<HTMLDivElement | HTMLButtonElement>
  ) => {
    e.stopPropagation(); 
    if (id && onDelete) {
      onDelete(id, title);
    }
  };

  return (
    <div
      onClick={onClick}
      className={type === SimpleCategoryItemTypes.BUTTON ? styles.buttonBox : styles.simpleBox}>
      {type === SimpleCategoryItemTypes.BUTTON && <img src={PlusIcon} alt='plusIcon.svg' />}
      <p>{title}</p>
      {
        isAutor && id &&
        <div className={styles.trashIcon} onClick={handleDeleteClick}>
          <img src={SmallTrash} alt='delete.svg' />
        </div>
      }
    </div>
  )
}

export default SimpleCategoryCard
